const CRITEO_USER_COOKIE = "CriteoSessionUserId";
const EVENT_TYPES = {
  viewCategory: "viewSpecialtyHome_API_",
  viewHome: "viewHome_API_",
  viewItem: "viewItem_API_"
};
const PLACEMENT_NAMES = {
  // HomePage Placement Names
  Carousel: "viewHome",
  CommerceDisplay: "viewHome",
  SpecialtyCarousel: "viewCategory",
  // PDP Placement Name
  SponsoredProductsCarousel: "viewItem"
};
const LOCALE_MAP = {
  "en-ca": "CABC-en",
  "en-us": "USBC-en",
  "fr-ca": "CABC-fr",
  USBD: "USBD-en"
};
export {
  CRITEO_USER_COOKIE,
  EVENT_TYPES,
  LOCALE_MAP,
  PLACEMENT_NAMES
};
